import { api } from "@bindery/convex-reader/api";
import type { FunctionReturnType } from "convex/server";

export const worksheetsApi = api.worksheets;

export type WorksheetGradeOutcome = FunctionReturnType<
  typeof worksheetsApi.grade
>;
export type WorksheetRefusal = Extract<
  WorksheetGradeOutcome,
  { status: "refused" }
>["reason"];

type Mutable<T> = T extends readonly (infer Item)[]
  ? Mutable<Item>[]
  : T extends object
    ? { -readonly [Key in keyof T]: Mutable<T[Key]> }
    : T;

/** Convex argument types are mutable; the contract types are readonly. */
export function forConvex<T>(value: T): Mutable<T> {
  return value as Mutable<T>;
}
